import { Routes, Route, Navigate } from 'react-router-dom'
import { AppShell } from './layout/AppShell'
import { InboxPage } from './pages/marketing/InboxPage'
import { ConversationDetailPage } from './pages/marketing/ConversationDetailPage'
import { SimulatorPage } from './pages/marketing/SimulatorPage'
import { ClientsPage } from './pages/marketing/ClientsPage'
import { ClientDetailPage } from './pages/marketing/ClientDetailPage'
import { SmartListsPage } from './pages/marketing/SmartListsPage'
import { FormsPage } from './pages/marketing/FormsPage'
import { TriggerLinksPage } from './pages/marketing/TriggerLinksPage'
import { RoutingRulesPage } from './pages/marketing/RoutingRulesPage'
import { WorkflowsPage } from './pages/marketing/WorkflowsPage'
import { BotsPage } from './pages/marketing/BotsPage'
import { WebhooksPage } from './pages/marketing/WebhooksPage'
import { ReputationPage } from './pages/marketing/ReputationPage'
import { HandoffsPage } from './pages/marketing/HandoffsPage'
import { ShadowReviewPage } from './pages/marketing/ShadowReviewPage'
import { DashboardPage } from './pages/marketing/DashboardPage'
import { InboxLayoutPage } from './pages/marketing/InboxLayoutPage'
import { FormViewerPage } from './pages/public/FormViewerPage'
import { LoginPage } from './pages/auth/LoginPage'
import { ChangePasswordPage } from './pages/auth/ChangePasswordPage'
import { AuthGuard } from './components/AuthGuard'
import { SubProcessorsPage } from './pages/marketing/SubProcessorsPage'
import { RgpdQueuePage } from './pages/marketing/RgpdQueuePage'
import { SubProcessorsPublicPage } from './pages/public/SubProcessorsPublicPage'
import { DsrFormPage } from './pages/public/DsrFormPage'
import { CampaignsPage } from './pages/marketing/CampaignsPage'
import { CampaignEditorPage } from './pages/marketing/CampaignEditorPage'
import { PipelinePage } from './pages/marketing/PipelinePage'
import { OpportunityDetailPage } from './pages/marketing/OpportunityDetailPage'
import { LostReasonsPage } from './pages/marketing/LostReasonsPage'
import { SyncPage } from './pages/marketing/SyncPage'
import { SecurityPage } from './pages/marketing/SecurityPage'
import { OptOutKeywordsPage } from './pages/marketing/OptOutKeywordsPage'

export default function App() {
  return (
    <Routes>
      {/* Rutas públicas — sin shell admin */}
      <Route path="/p/forms/:slug" element={<FormViewerPage />} />
      <Route path="/legal/sub-procesadores" element={<SubProcessorsPublicPage />} />
      <Route path="/rgpd" element={<DsrFormPage />} />

      {/* Auth — sin shell, sin guard */}
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/change-password"
        element={
          <AuthGuard>
            <ChangePasswordPage />
          </AuthGuard>
        }
      />

      {/* Rutas admin con shell + AuthGuard */}
      <Route
        element={
          <AuthGuard>
            <AppShell />
          </AuthGuard>
        }
      >
        <Route path="/" element={<Navigate to="/marketing/dashboard" replace />} />
        <Route path="/marketing" element={<Navigate to="/marketing/dashboard" replace />} />
        <Route path="/marketing/dashboard" element={<DashboardPage />} />
        <Route path="/marketing/inbox" element={<InboxLayoutPage />} />
        <Route path="/marketing/inbox/:id" element={<InboxLayoutPage />} />
        <Route path="/marketing/inbox-classic" element={<InboxPage />} />
        <Route path="/marketing/inbox-classic/:id" element={<ConversationDetailPage />} />
        <Route path="/marketing/clients" element={<ClientsPage />} />
        <Route path="/marketing/clients/:id" element={<ClientDetailPage />} />
        <Route path="/marketing/smart-lists" element={<SmartListsPage />} />
        <Route path="/marketing/forms" element={<FormsPage />} />
        <Route path="/marketing/trigger-links" element={<TriggerLinksPage />} />
        <Route path="/marketing/routing-rules" element={<RoutingRulesPage />} />
        <Route path="/marketing/workflows" element={<WorkflowsPage />} />
        <Route path="/marketing/bots" element={<BotsPage />} />
        <Route path="/marketing/handoffs" element={<HandoffsPage />} />
        <Route path="/marketing/shadow-review" element={<ShadowReviewPage />} />
        <Route path="/marketing/webhooks" element={<WebhooksPage />} />
        <Route path="/marketing/reputation" element={<ReputationPage />} />
        <Route path="/marketing/sub-processors" element={<SubProcessorsPage />} />
        <Route path="/marketing/rgpd" element={<RgpdQueuePage />} />
        <Route path="/marketing/campaigns" element={<CampaignsPage />} />
        <Route path="/marketing/campaigns/:id" element={<CampaignEditorPage />} />
        <Route path="/marketing/pipeline" element={<PipelinePage />} />
        <Route path="/marketing/opportunities/:id" element={<OpportunityDetailPage />} />
        <Route path="/marketing/lost-reasons" element={<LostReasonsPage />} />
        <Route path="/marketing/simulator" element={<SimulatorPage />} />
        <Route path="/marketing/sync" element={<SyncPage />} />
        <Route path="/marketing/security" element={<SecurityPage />} />
        <Route path="/marketing/opt-out-keywords" element={<OptOutKeywordsPage />} />
        <Route
          path="*"
          element={
            <div className="p-8 font-mono text-sm text-ink-700">404 — ruta no encontrada.</div>
          }
        />
      </Route>
    </Routes>
  )
}
